import React from "react";
import Edit_Customer from "./Edit_Customer";

const Edit_Customer_Dynamic = (props) => (
  <Edit_Customer {...props} useDynamicForm />
);

export default Edit_Customer_Dynamic;
